import "./SuccessOnboarding.scss"
import React, { useEffect } from 'react'
import SecondaryLayout from "../../../../layouts/SecondaryLayout"
import successJson from '../../../../assets/lotties/SuccessAnimation.json';
import { ReactComponent as JcrLogo } from '../../../../assets/jcr-logo.svg' 
import Lottie from "react-lottie-player"
import { useDispatch } from "react-redux";
import { setBasicDetailsFilled } from "../../RecruitmentDataSlice";
import { ROUTES } from '../../../../config/routes'
import { useNavigate } from "react-router-dom";
function SuccessOnboarding() {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  useEffect(() => {
    dispatch(setBasicDetailsFilled(true))
    const onboardingLandingPath = `${ROUTES.RECRUITMENT}/${ROUTES.ONBOARDING}`
    const timeoutId = setTimeout(async () => {
      navigate(onboardingLandingPath)
    }, 5000)

    return async () => {
      clearTimeout(timeoutId)
    }

  }, [])


  return (
    <div className="SuccessOnboarding">
      <SecondaryLayout showHexBackground={false} isFluidContainer={false}>
        <div className="flex flex-column h-screen justify-content-center align-items-center">
          <JcrLogo className="my-3" height='1.5rem' />
          <div className="flex flex-column justify-content-center align-items-center successBox">
            <Lottie play loop={false} animationData={successJson} style={{ height: 250 }} />
            <h1 className='BankDetailsGradientText font-bold text-2xl text-white mb-3' >Congratulations!</h1>
            <p className="text-white mb-0">You have been successfully onboarded. You will hear back from HR Team shortly.</p>
            <p className="text-white text-xs font-light">You will be redirected to onboarding home page in 5 seconds.</p>
          </div>
        </div>
      </SecondaryLayout>
    </div>
  )
}

export default SuccessOnboarding